import { Stack, Tooltip } from "@mui/material";
import { ReactComponent as AttachmentsActiveIcon } from "images/attachments-icon-active.svg";
import { ReactComponent as AttachmentsIcon } from "images/attachments-icon.svg";
import { ReactComponent as ResourceIcon } from "images/resource-icon.svg";
import { customColors } from "models/customColors";
import ConditionalBoldText from "UI/ConditionalBoldText";
import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";
import { displayCreatedAt } from "utils/helpers";
import { SourceOfEvent } from "./SourceOfEvent";
import Status from "./Status";

export const questionsColumns = [
  {
    label: "Created At",
    field: "createdAt",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: (row) => (
      <ConditionalBoldText text={displayCreatedAt(row)} row={row} />
    ),
  },
  // {
  //   label: "Type",
  //   field: "type",
  //   xs: 1,
  //   sm: 1,
  //   md: 1,
  //   renderer: ({ type }) => (
  //     <TextFieldWithEllipsis>{type}</TextFieldWithEllipsis>
  //   ),
  // },
  // {
  //   label: "Button ID",
  //   field: "buttonId",
  //   xs: 1,
  //   sm: 1,
  //   md: 1,
  //   renderer: ({ buttonId, buttonType }) => (
  //     <TextFieldWithEllipsis>
  //       {["Virtual", "Soft", "Digital"].includes(buttonType)
  //         ? `${String(buttonId).slice(0, 8)}...`
  //         : buttonId}
  //     </TextFieldWithEllipsis>
  //   ),
  // },
  // {
  //   label: "Name",
  //   field: "buttonName",
  //   xs: 0.75,
  //   sm: 0.75,
  //   md: 0.75,
  //   renderer: ({ buttonName }) => (
  //     <TextFieldWithEllipsis>{buttonName}</TextFieldWithEllipsis>
  //   ),
  // },
  // {
  //   label: "Type",
  //   xs: 1,
  //   sm: 1,
  //   md: 1,
  //   renderer: ({ buttonType }) => (
  //     <TextFieldWithEllipsis>
  //       {convertDeviceType(buttonType)}
  //     </TextFieldWithEllipsis>
  //   ),
  // },
  {
    label: "Practice",
    field: "practiceName",
    xs: 1.25,
    sm: 1.25,
    md: 1.25,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.practiceName} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Region",
    field: "practiceMarketingRegion",
    xs: 0.75,
    sm: 0.75,
    md: 0.75,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.practiceMarketingRegion} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  // {
  //   label: "Speciality",
  //   field: "practiceSpeciality",
  //   xs: 1,
  //   sm: 1,
  //   md: 1,
  //   renderer: ({ practiceSpeciality }) => (
  //     <TextFieldWithEllipsis>{practiceSpeciality}</TextFieldWithEllipsis>
  //   ),
  // },
  {
    label: "Provider",
    field: "providers",
    xs: 1.25,
    sm: 1.25,
    md: 1.25,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.providers} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Sender",
    field: "originatorName",
    xs: 1,
    sm: 1,
    md: 1,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.originatorName} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Phone",
    field: "originatorPhone",
    xs: 1.25,
    sm: 1.25,
    md: 1.25,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.originatorPhone} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Question",
    field: "question",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.question} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Location",
    field: "locationName",
    xs: 0.75,
    sm: 0.75,
    md: 0.75,
    renderer: ({ locationName }) => (
      <TextFieldWithEllipsis>{locationName}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Recipients",
    field: "specialists",
    xs: 1,
    sm: 1,
    md: 1,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.specialists} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: (
      <Tooltip title="Attachments">
        <AttachmentsIcon />
      </Tooltip>
    ),
    field: "attachments",
    xs: 0.5,
    sm: 0.5,
    md: 0.5,
    renderer: ({ attachments }) =>
      attachments && (
        <Stack
          direction="row"
          gap={0.35}
          sx={{ color: customColors.mainMessageBlue }}
        >
          <AttachmentsActiveIcon /> {attachments ?? 0}
        </Stack>
      ),
  },
  {
    label: (
      <Tooltip title="Event source">
        <ResourceIcon />
      </Tooltip>
    ),
    field: "buttonType",
    xs: 0.5,
    sm: 0.5,
    md: 0.5,
    renderer: ({ buttonId, buttonType }) => (
      <SourceOfEvent buttonId={buttonId} buttonType={buttonType} />
    ),
  },
  {
    label: "Status",
    field: "status",
    xs: 0.75,
    sm: 0.75,
    md: 0.75,
    renderer: ({ status }) => <Status value={status} />,
  },
];

export const questionsMobileColumns = [
  {
    label: "Created At",
    field: "createdAt",
    xs: 4,
    sm: 4,
    md: 4,
    renderer: (row) => (
      <ConditionalBoldText text={displayCreatedAt(row)} row={row} />
    ),
  },
  {
    label: "Practice",
    field: "practiceName",
    xs: 3.5,
    sm: 3.5,
    md: 3.5,
    renderer: (row) => (
      <ConditionalBoldText
        text={
          <TextFieldWithEllipsis>{row?.practiceName}</TextFieldWithEllipsis>
        }
        row={row}
      />
    ),
  },
  {
    label: "Sender",
    field: "originatorName",
    xs: 2.5,
    sm: 2.5,
    md: 2.5,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.originatorName} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Status",
    field: "status",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ status }) => <Status value={status} />,
  },
];
